import * as React from "react";

export interface IVideosProps {
  videos: IVideo[];
}

export interface IVideosState {
  // videos: IVideo[];
}
export interface IVideo {
  type: string;
  link: string;
}

export default class Videos extends React.Component<
  IVideosProps,
  IVideosState
> {
  constructor(props: IVideosProps) {
    super(props);

    this.state = {
      // videos: [],//this.getVideos()
    };
    // this.getVideos();
  }

  public render(): React.ReactElement<IVideosProps> {
    return (
      <div className={"row"}>
        {this.props.videos.map((e) => {
          return (
            <div className={"col-sm-6"} key={e.link}>
              <iframe
                src={e.link}
                width="100%"
                allowFullScreen
                title={e.link}
              />
            </div>
          );
        })}
      </div>
    );
  }
}
